// extracted by mini-css-extract-plugin
module.exports = {"main":"gZiYVVKs0dYhYi4zm1wxF","wrapper":"Sx-uD-0fs_TBTeCH0I8d0","img":"_1SioJCp2piMyYzk3cpEAPE","pagination":"_22Ht0Oo7loW_WkReObss0N"};